<template>
  <div class="markdown-body" v-html="parsedMessage" />
</template>
<script setup lang="ts">
import { computed } from "vue";

import DOMPurify from "dompurify";
import "github-markdown-css/github-markdown.css";
import { marked } from "marked";

const { content } = defineProps<{ content: string }>();

const parsedMessage = computed(() => {
  const rawHtml = marked.parse(content) as string;
  return DOMPurify.sanitize(rawHtml).trimEnd();
});
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.markdown-body {
  @apply bg-transparent text-[14px] text-inherit;

  & :deep(p) {
    @apply mb-0;
  }

  & :deep(ul) {
    @apply list-disc;
  }

  & :deep(ol) {
    @apply list-decimal;
  }

  &.truncate.whitespace-nowrap {
    & :deep(p) {
      @apply truncate whitespace-nowrap;
    }
  }
}
</style>
